import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useQuery } from '@apollo/client';
import { useSelector } from 'react-redux';

import DashboardPage from '../../components/OwnerReporting/dashboard/DashboardPage';
import {
  parseDashboardQuery, applyDashboardPatch, buildDashboardPath, buildDashboardVariables,
} from '../../components/OwnerReporting/dashboard/dashboardUrlState';
import history from '../../core/history';

import getOwnerDashboard from './ownerDashboard.graphql';

// Reads the filters from the URL (query given by the route), asks the server for the data and hands them to the page.
// A filter change = navigation to the new URL (the URL is the single source of truth: shareable, reloadable).
const OwnerDashboardContainer = ({ query }) => {
  const state = useMemo(() => parseDashboardQuery(query), [JSON.stringify(query || {})]);
  const convertCurrency = useSelector((store) => store.currency && store.currency.to) || undefined;
  const variables = useMemo(() => buildDashboardVariables(state, convertCurrency), [state, convertCurrency]);

  const { data, previousData, loading, error, refetch } = useQuery(getOwnerDashboard, {
    variables,
    fetchPolicy: 'network-only',
    ssr: false,
    notifyOnNetworkStatusChange: true,
  });

  // Keep the previous result visible (dimmed) while a new filter loads, instead of flashing the skeleton.
  const result = (data && data.getOwnerDashboard) || (loading && previousData ? previousData.getOwnerDashboard : null);

  const go = (next) => history.push(buildDashboardPath(next));

  return (
    <DashboardPage
      state={state}
      loading={loading}
      networkError={Boolean(error)}
      dashboard={result}
      onChange={(patch) => go(applyDashboardPatch(state, patch))}
      onRetry={() => refetch()}
      onReset={() => go(applyDashboardPatch(state, { listId: null }))}
    />
  );
};

OwnerDashboardContainer.propTypes = { query: PropTypes.object };

export default OwnerDashboardContainer;
